export default __webpack_public_path__ + "static/media/xYELD.f5633a50.svg";